// spec-48 W1: added 'setup-registration' (renamed from 'setup'), 'transactions', 'post-incorporation'
export type ModuleId = 'jylaw' | 'setup-registration' | 'transactions' | 'post-incorporation'
  | 'retainer' | 'court' | 'delegation' | 'wiki' | 'crm' | 'documents' | 'legal-services';

export interface ModuleConfig {
  id: ModuleId;
  label: string;
  accent: string;
  icon: string;
  description: string;
}

// Accents tuned for AA contrast (>= 4.5:1) against the off-white surface
// (#FAFAF7) introduced in the Option A brand. Family: deep saturated tones
// that harmonise with the primary navy + bronze pair without competing.
// spec-48 W3: reordered to DEC-48-2 (volume-prioritised service lines first, cross-cutting after)
export const MODULE_CONFIGS: Record<ModuleId, ModuleConfig> = {
  // ── Service-line tabs (DEC-48-2 order) ──────────────────────────────────
  'retainer': {
    id: 'retainer',
    label: 'Retainer',
    accent: '#92400E',
    icon: 'Box',
    description: 'Retainer entities',
  },
  'transactions': {
    id: 'transactions',
    label: 'Transactions',
    accent: '#1565C0',
    icon: 'SwapHoriz',
    description: 'Corporate transactions pipeline — 18 transaction types (spec-48)',
  },
  'setup-registration': {
    id: 'setup-registration',
    label: 'Setup — Registration',
    accent: '#2F6741',
    icon: 'Box',
    description: 'Company registration and formation (spec-48 rename from setup)',
  },
  'post-incorporation': {
    id: 'post-incorporation',
    label: 'Post-Incorporation',
    accent: '#6A1B9A',
    icon: 'Checklist',
    description: 'Post-incorporation entity setup (spec-48)',
  },
  'legal-services': {
    id: 'legal-services',
    label: 'Legal Services',
    accent: '#7c4f8a',
    icon: 'Gavel',
    description: 'Legal matters, transactions, and billing — NDA, M&A, contracts',
  },
  'court': {
    id: 'court',
    label: 'Court',
    accent: '#991B1B',
    icon: 'Box',
    description: 'Court entities',
  },
  // ── Cross-cutting tabs (DEC-48-3 unchanged) ──────────────────────────────
  crm: {
    id: 'crm',
    label: 'CRM',
    accent: '#047857',
    icon: 'People',
    description: 'Inquiry-to-engagement pipeline, client KYC, activity timeline',
  },
  documents: {
    id: 'documents',
    label: 'Documents',
    accent: '#1F4E5F',
    icon: 'FileText',
    description: 'Document library — POAs, AOAs, CRs, templates, expiry tracking',
  },
  wiki: {
    id: 'wiki',
    label: 'Knowledge Wiki',
    accent: '#0F766E',
    icon: 'BookMarked',
    description: 'LLM-maintained knowledge base — ingest, query, lint',
  },
  'delegation': {
    id: 'delegation',
    label: 'Delegation',
    accent: '#5B21B6',
    icon: 'Box',
    description: 'Two-tier deputy chain + SR 25k hard escalation (spec-17)',
  },
  'jylaw': {
    id: 'jylaw',
    label: 'Jylaw',
    accent: '#234E70',
    icon: 'Box',
    description: 'Jylaw entities',
  },
};

export const MODULE_LIST: ModuleConfig[] = Object.values(MODULE_CONFIGS);
